import * as React from 'react';

import { IconRegularChevronRight, Text } from '@notino/react-styleguide';
import { DeliveryVariant } from '@notino/shared/definitions/types';

import { useFormattedPrice } from '@components/PriceLabel/useFormattedPrice';
import { useFeatureFlags } from '@context/featureFlags/FeatureFlagsProvider';

import { LeftIconWrapper } from '../styled';

import { DeliveryDate, DeliveryInfoWrapper, Name } from './styled';

interface IDeliveryLineProps {
  showIcon: boolean;
  icon: JSX.Element;
  name: string;
  description: JSX.Element | string;
  isInactive: boolean;
  price: number;
}

export const DeliveryLine: React.FC<IDeliveryLineProps> = ({
  showIcon,
  icon,
  name,
  description,
  isInactive,
  price,
}) => {
  const { experiment_pd_delivery_variant } = useFeatureFlags();
  const { formattedPriceWithCurrency } = useFormattedPrice({ value: price });

  return (
    <>
      <LeftIconWrapper>
        {showIcon &&
          React.cloneElement(icon, {
            color: isInactive ? 'icon.disabled' : 'icon.primary',
            width: '20px',
            height: '20px',
          })}
      </LeftIconWrapper>

      <DeliveryInfoWrapper>
        <Name isInactive={isInactive}>{name}</Name>

        <DeliveryDate isInactive={isInactive}>{description}</DeliveryDate>

        {experiment_pd_delivery_variant === DeliveryVariant.Drawer && (
          <Text typography="labelRegular" color="text.tertiary" marginTop="4px">
            {formattedPriceWithCurrency}
          </Text>
        )}
      </DeliveryInfoWrapper>

      {experiment_pd_delivery_variant !== DeliveryVariant.Default && (
        <IconRegularChevronRight width="1rem" height="1rem" />
      )}
    </>
  );
};
